module.exports = __webpack_public_path__ + "static/krystian-biela-x1-cf7d6953242887646025cd55738fb98c.jpg";